var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map-control-switch leaflet-bottom" },
    [
      _c("div", { staticClass: "icon-container", on: { click: _vm.zoomIn } }, [
        _c("i", { staticClass: "el-icon-zoom-in" })
      ]),
      _c("div", { staticClass: "icon-container", on: { click: _vm.zoomOut } }, [
        _c("i", { staticClass: "el-icon-zoom-out" })
      ]),
      _c("div", { staticClass: "icon-container", on: { click: _vm.measure } }, [
        _c("img", { attrs: { src: _vm.measureIcon } })
      ]),
      _c(
        "div",
        { staticClass: "icon-container", on: { click: _vm.measureClear } },
        [_c("img", { attrs: { src: _vm.measureClearIcon } })]
      ),
      _c("popover-select", {
        attrs: {
          text: "",
          icon: "layer",
          options: [
            { value: "tiandi", text: "天地图" },
            { value: "gaode", text: "高德地图" }
          ]
        },
        model: {
          value: _vm.map,
          callback: function($$v) {
            _vm.map = $$v
          },
          expression: "map"
        }
      }),
      _vm.showLayers.length > 0
        ? _c(
            "div",
            {
              directives: [
                { name: "drag", rawName: "v-drag:bottom", arg: "bottom" }
              ],
              staticClass: "color-simple-img"
            },
            [
              _vm.showLayers.length > 1
                ? _c("popover-select", {
                    attrs: {
                      text: _vm.currentImgText,
                      icon: "el-icon-arrow-down",
                      options: _vm.imgOptions
                    },
                    model: {
                      value: _vm.currentImg,
                      callback: function($$v) {
                        _vm.currentImg = $$v
                      },
                      expression: "currentImg"
                    }
                  })
                : _vm._e(),
              _c("div", { style: _vm.imgStyle })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }